import http from './http';

/**
 * 首页活动列表
 */
export function gethome(data) {
  return http("get", '/app/home/index', data);
}

export function getevent(data) {
  return http("get", '/app/event/' + data.id + '/' + data.userid);
}

export function getparent(id) {
  return http("get", '/app/event/parent', id);
}

export function checkUserAndGenToken(params) {
  return http("POST", '/user/checkUserAndGenToken', params);
}

export function getmyevents(params) {
  return http("get", '/app/my/events', params);
}

export function getsystemlis(id) {
  return http("get", 'app/event/type/' + id);
}

export function goto(params) {
  return http("get", 'app/go', params);
}

export function cancle(params) {
  return http("get", 'app/cancellation/event', params);
}



export function sdmuser(params) {
  return http("post", '/app/sdm/user', params)
}



export function modifysdmuser(id) {
  return http("get", '/app/sdm/user/' + id)
}

export function putsdmuser(params) {
  return http("put", '/app/sdm/user', params)
}


export function eventperson(data) {
  return http("post", '/app/event/person', data)
}


export function papticipants(data) {
  return http("get", '/app/papticipants', data)
}




export function goevent(data) {
  return http("get", '/app/go/event/detail', data)
}


export function countrylocation(data) {
  return http("get", '/app/country/location', data)
}





export function recommendations(data) {
  return http("get", '/app/recommendations/' + data.id + '/' + data.distance);
}

export function getwhether(data) {
  return http("get", '/app/whether', data);
}



export function getperson(id, data) {
  // return http("get", 'app/join/event/person' , data)
  // return http("get", 'app/join/event/person/' +data)
  return http("get", 'app/join/event/person/' + id, data)
}


export function getnearby(eventId, distance, sdmUserId) {
  return http("get", 'app/nearby/' + eventId + '/' + distance + '/' + sdmUserId)
}


export function getopen(data) {
  return http("get", '/app/event/open', data);
}

export function setsdmlist() {
  return http("get", '/app/sdm/list');
}


export function getkeywords(data) {
  return http("get", '/app/event/keywords',data);
}


export function getindustryType(data) {
  return http("get", '/app/industryType',data);
}


